import { ApplicationInsights, ITelemetryItem } from '@microsoft/applicationinsights-web';

export default function() {
  const appInsights = new ApplicationInsights({
    config: {
      instrumentationKey: (window.ENV_DATA || {}).aiKey || process.env.AI_KEY!,
      isCookieUseDisabled: true,
      disableTelemetry: process.env.NODE_ENV === 'development',
      disableExceptionTracking: true
    }
  });

  function isIgnoredDependency(envelope: ITelemetryItem) {
    const isNotGuestline = !envelope?.baseData?.target.split('?')[0].includes('guestline');
    const isHealthCheck = ['status/ready', 'status/health'].some((str) =>
      envelope?.baseData?.target.includes(str)
    );
    const isSuccess = envelope?.baseData?.success;
    
    return Boolean(isNotGuestline || isHealthCheck || isSuccess);
  }
  const telemetryInitializer = (envelope: ITelemetryItem) => {
    if (envelope.tags) {
      envelope.tags['ai.cloud.role'] = 'guestline-gxp-tag';
      envelope.tags['ai.cloud.roleInstance'] = 'guestline-gxp-tag';
    }

    if (envelope.baseType === 'RemoteDependencyData' && isIgnoredDependency(envelope)) {
      return false;
    }

    return true;
  };

  appInsights.loadAppInsights();
  appInsights.addTelemetryInitializer(telemetryInitializer);
  window.GLAppInsights = appInsights;
}
